import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Sofía Martínez',
  role: 'Freelance Marketing Digital',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  text: 'Llevaba 3 años como freelance y nunca sabía si iba a poder pagar la renta. El reto de 30 días me cambió todo: ahora tengo 3 meses de gastos ahorrados y por fin duermo tranquila. Lo mejor es que no tuve que ganar más, solo organizar lo que ya tenía.',
  highlight: 'De vivir al día → 3 meses de ahorro en 6 meses',
  rating: 5
}, {
  name: 'Daniela Reyes',
  role: 'Emprendedora + Mamá',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  text: 'Mi esposo manejaba todo el dinero y yo me sentía invisible. Después de leer "Dinero en Pareja", tuvimos nuestra primera conversación real sobre finanzas. Ahora tomamos decisiones juntos y me siento empoderada. Hasta abrí mi cuenta de ahorros personal.',
  highlight: 'De sentirse invisible → Tomar decisiones financieras en pareja',
  rating: 5
}, {
  name: 'Lucía Hernández',
  role: 'Maestra con ventas por catálogo',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  text: 'Tenía $15,000 en deudas de tarjetas y cada mes solo pagaba el mínimo. Con el "Plan para Salir de Deudas" hice un calendario realista. En 8 meses pagué $8,000 y por primera vez en años, veo la luz al final del túnel. Ya no me da miedo abrir el estado de cuenta.',
  highlight: 'Pagó $8,000 de deuda en 8 meses',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-20 bg-[#1e3a5f] text-white relative overflow-hidden" data-id="element-559">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-560">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#d4a574] rounded-full blur-3xl" data-id="element-561" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-[#f4e4d7] rounded-full blur-3xl" data-id="element-562" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-563">
        <div className="text-center mb-16" data-id="element-564">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-565">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-566">
              Historias reales de transformación
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-567">
              Ellas también sentían miedo e incertidumbre. Hoy tienen el
              control.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-568">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-2xl relative hover:bg-white/15 transition-colors duration-300" data-id="element-569">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#d4a574] opacity-30" data-id="element-570" />

              <div className="flex items-center gap-1 mb-4" data-id="element-571">
                {[...Array(item.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-572" />)}
              </div>

              <p className="text-gray-200 mb-4 leading-relaxed" data-id="element-573">
                "{item.text}"
              </p>

              {/* Transformation highlight */}
              <div className="mb-6 p-3 bg-[#d4a574]/20 border border-[#d4a574]/30 rounded-lg" data-id="element-574">
                <p className="text-[#d4a574] text-sm font-semibold" data-id="element-575">
                  ✨ {item.highlight}
                </p>
              </div>

              <div className="flex items-center gap-4" data-id="element-576">
                <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#d4a574]" data-id="element-577" />
                <div data-id="element-578">
                  <h4 className="font-bold text-white text-sm" data-id="element-579">{item.name}</h4>
                  <p className="text-[#d4a574] text-xs" data-id="element-580">{item.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust indicator */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center mt-12" data-id="element-581">
          <p className="text-gray-300 text-sm" data-id="element-582">
            Más de 500 mujeres ya transformaron su relación con el dinero
          </p>
        </motion.div>
      </div>
    </section>;
}